// extracted by mini-css-extract-plugin
export default {"wrapper":"burger-constructor-empty_wrapper__ncpta","img":"burger-constructor-empty_img__YRC2T"};